export default __webpack_public_path__ + "images/VS.04a9532.png";